export const colors = [
  'Beige',
  'Black',
  'Blue',
  'Brown',
  'Clear',
  'Gold',
  'Gray',
  'Green',
  'Multi-Color',
  'Orange',
  'Pink',
  'Purple',
  'Red',
  'Silver',
  'White',
  'Yellow'
]
